// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__OfizZ","approved":"Status_approved__2eI3_","rejected":"Status_rejected__1cbwS","expired":"Status_expired__1KWP2","label":"Status_label__3AEVn"};